module.exports = [
  {
    "name": "United Kingdom",
    "capitalCity": "London",
    "currencySymbol": "£",
    "currencyCode": "GBP",
    "callingCode": "+44",
    "hasDescription": true,
    "hasFooter": true,
    "cities": [
      {
        "name": "Cardiff",
        "slug": "cardiff",
        "hasDescription": true
      },
      {
        "name": "Leeds",
        "slug": "leeds",
        "hasDescription": true
      },
      {
        "name": "London",
        "slug": "london",
        "hasDescription": true
      },
      {
        "name": "Manchester",
        "slug": "manchester",
        "hasDescription": true
      },
      {
        "name": "Nottingham",
        "slug": "nottingham",
        "hasDescription": true
      },
      {
        "name": "Sheffield",
        "slug": "sheffield",
        "hasDescription": true
      }
    ],
    "slug": "united-kingdom"
  },
  {
    "name": "Portugal",
    "capitalCity": "Lisbon",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+351",
    "hasDescription": true,
    "hasFooter": true,
    "cities": [
      {
        "name": "Braga",
        "slug": "braga",
        "hasDescription": true
      },
      {
        "name": "Coimbra",
        "slug": "coimbra",
        "hasDescription": true
      },
      {
        "name": "Lisbon",
        "slug": "lisbon",
        "hasDescription": true
      },
      {
        "name": "Porto",
        "slug": "porto",
        "hasDescription": true
      }
    ],
    "slug": "portugal"
  },
  {
    "name": "Spain",
    "capitalCity": "Madrid",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+34",
    "hasDescription": true,
    "hasFooter": true,
    "cities": [
      {
        "name": "Alicante",
        "slug": "alicante",
        "hasDescription": true
      },
      {
        "name": "Barcelona",
        "slug": "barcelona",
        "hasDescription": true
      },
      {
        "name": "Bilbao",
        "slug": "bilbao",
        "hasDescription": true
      },
      {
        "name": "Cádiz",
        "slug": "cadiz",
        "hasDescription": true
      },
      {
        "name": "Cordoba",
        "slug": "cordoba",
        "hasDescription": true
      },
      {
        "name": "Granada",
        "slug": "granada",
        "hasDescription": true
      },
      {
        "name": "Madrid",
        "slug": "madrid",
        "hasDescription": true
      },
      {
        "name": "Malaga",
        "slug": "malaga",
        "hasDescription": true
      },
      {
        "name": "Murcia",
        "slug": "murcia",
        "hasDescription": true
      },
      {
        "name": "Palma de Mallorca",
        "slug": "palma-de-mallorca",
        "hasDescription": true
      },
      {
        "name": "Salamanca",
        "slug": "salamanca",
        "hasDescription": true
      },
      {
        "name": "Seville",
        "slug": "seville",
        "hasDescription": true
      },
      {
        "name": "Valencia",
        "slug": "valencia",
        "hasDescription": true
      },
      {
        "name": "Zaragoza",
        "slug": "zaragoza",
        "hasDescription": true
      }
    ],
    "slug": "spain"
  },
  {
    "name": "Italy",
    "capitalCity": "Rome",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+39",
    "hasDescription": true,
    "hasFooter": true,
    "cities": [
      {
        "name": "Bologna",
        "slug": "bologna",
        "hasDescription": true
      },
      {
        "name": "Florence",
        "slug": "florence",
        "hasDescription": true
      },
      {
        "name": "Milan",
        "slug": "milan",
        "hasDescription": true
      },
      {
        "name": "Rome",
        "slug": "rome",
        "hasDescription": true
      },
      {
        "name": "Turin",
        "slug": "turin",
        "hasDescription": true
      }
    ],
    "slug": "italy"
  },
  {
    "name": "France",
    "capitalCity": "Paris",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+33",
    "hasDescription": true,
    "hasFooter": false,
    "cities": [
      {
        "name": "Lille",
        "slug": "lille",
        "hasDescription": false
      },
      {
        "name": "Paris",
        "slug": "paris",
        "hasDescription": true
      },
      {
        "name": "Toulouse",
        "slug": "toulouse",
        "hasDescription": true
      }
    ],
    "slug": "france"
  },
  {
    "name": "Germany",
    "capitalCity": "Berlin",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+49",
    "hasDescription": true,
    "hasFooter": true,
    "cities": [
      {
        "name": "Berlin",
        "slug": "berlin",
        "hasDescription": true
      },
      {
        "name": "Frankfurt",
        "slug": "frankfurt",
        "hasDescription": true
      },
      {
        "name": "Leipzig",
        "slug": "leipzig",
        "hasDescription": true
      },
      {
        "name": "Munich",
        "slug": "munich",
        "hasDescription": true
      }
    ],
    "slug": "germany"
  },
  {
    "name": "Argentina",
    "capitalCity": "Buenos Aires",
    "currencySymbol": "$",
    "currencyCode": "ARS",
    "callingCode": "+54",
    "hasDescription": true,
    "hasFooter": false,
    "cities": [
      {
        "name": "Buenos Aires",
        "slug": "buenos-aires",
        "hasDescription": true
      }
    ],
    "slug": "argentina"
  },
  {
    "name": "Australia",
    "capitalCity": "Canberra",
    "currencySymbol": "$",
    "currencyCode": "AUD",
    "callingCode": "+61",
    "hasDescription": true,
    "hasFooter": false,
    "cities": [
      {
        "name": "Adelaide",
        "slug": "adelaide",
        "hasDescription": true
      },
      {
        "name": "Brisbane",
        "slug": "brisbane",
        "hasDescription": true
      },
      {
        "name": "Gold Coast",
        "slug": "gold-coast",
        "hasDescription": true
      },
      {
        "name": "Melbourne",
        "slug": "melbourne",
        "hasDescription": true
      },
      {
        "name": "Perth",
        "slug": "perth",
        "hasDescription": true
      },
      {
        "name": "Sydney",
        "slug": "sydney",
        "hasDescription": true
      }
    ],
    "slug": "australia"
  },
  {
    "name": "Canada",
    "capitalCity": "Ottawa",
    "currencySymbol": "CA$",
    "currencyCode": "CAD",
    "callingCode": "+1",
    "hasDescription": true,
    "hasFooter": false,
    "cities": [
      {
        "name": "Calgary",
        "slug": "calgary",
        "hasDescription": true
      },
      {
        "name": "Montreal",
        "slug": "montreal",
        "hasDescription": true
      },
      {
        "name": "Ottawa",
        "slug": "ottawa",
        "hasDescription": true
      },
      {
        "name": "Surrey",
        "slug": "surrey",
        "hasDescription": true
      },
      {
        "name": "Toronto",
        "slug": "toronto",
        "hasDescription": true
      },
      {
        "name": "Vancouver",
        "slug": "vancouver",
        "hasDescription": true
      }
    ],
    "slug": "canada"
  },
  {
    "name": "Denmark",
    "capitalCity": "Copenhagen",
    "currencySymbol": "Kr.",
    "currencyCode": "DKK",
    "callingCode": "+45",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Aarhus",
        "slug": "aarhus",
        "hasDescription": false
      },
      {
        "name": "Copenhagen",
        "slug": "copenhagen",
        "hasDescription": true
      }
    ],
    "slug": "denmark"
  },
  {
    "name": "Netherlands",
    "capitalCity": "Amsterdam",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+31",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Amsterdam",
        "slug": "amsterdam",
        "hasDescription": true
      },
      {
        "name": "Castricum",
        "slug": "castricum",
        "hasDescription": false
      },
      {
        "name": "Delft",
        "slug": "delft",
        "hasDescription": false
      },
      {
        "name": "Eindhoven",
        "slug": "eindhoven",
        "hasDescription": false
      },
      {
        "name": "Groningen",
        "slug": "groningen",
        "hasDescription": false
      },
      {
        "name": "Maastricht",
        "slug": "maastricht",
        "hasDescription": false
      },
      {
        "name": "Rotterdam",
        "slug": "rotterdam",
        "hasDescription": false
      },
      {
        "name": "The Hague",
        "slug": "the-hague",
        "hasDescription": true
      },
      {
        "name": "Utrecht",
        "slug": "utrecht",
        "hasDescription": false
      }
    ],
    "slug": "netherlands"
  },
  {
    "name": "Norway",
    "capitalCity": "Oslo",
    "currencySymbol": "kr",
    "currencyCode": "NOK",
    "callingCode": "+47",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Oslo",
        "slug": "oslo",
        "hasDescription": true
      }
    ],
    "slug": "norway"
  },
  {
    "name": "Sweden",
    "capitalCity": "Stockholm",
    "currencySymbol": "kr",
    "currencyCode": "SEK",
    "callingCode": "+46",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Gothenburg",
        "slug": "gothenburg",
        "hasDescription": false
      },
      {
        "name": "Stockholm",
        "slug": "stockholm",
        "hasDescription": true
      }
    ],
    "slug": "sweden"
  },
  {
    "name": "United States",
    "capitalCity": "Washington, D.C.",
    "currencySymbol": "$",
    "currencyCode": "USD",
    "callingCode": "+1",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Atlanta",
        "slug": "atlanta",
        "hasDescription": true
      },
      {
        "name": "Boston",
        "slug": "boston",
        "hasDescription": true
      },
      {
        "name": "Chicago",
        "slug": "chicago",
        "hasDescription": true
      },
      {
        "name": "Houston",
        "slug": "houston",
        "hasDescription": true
      },
      {
        "name": "Los Angeles",
        "slug": "los-angeles",
        "hasDescription": true
      },
      {
        "name": "New York",
        "slug": "new-york",
        "hasDescription": true
      },
      {
        "name": "Orlando",
        "slug": "orlando",
        "hasDescription": true
      },
      {
        "name": "Philadelphia",
        "slug": "philadelphia",
        "hasDescription": true
      },
      {
        "name": "San Diego",
        "slug": "san-diego",
        "hasDescription": true
      },
      {
        "name": "San Francisco",
        "slug": "san-francisco",
        "hasDescription": true
      }
    ],
    "slug": "united-states"
  },
  {
    "name": "South Africa",
    "capitalCity": "Cape Town",
    "currencySymbol": "R",
    "currencyCode": "ZAR",
    "callingCode": "+27",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Cape Town",
        "slug": "cape-town",
        "hasDescription": true
      }
    ],
    "slug": "south-africa"
  },
  {
    "name": "Austria",
    "capitalCity": "Vienna",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+43",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Vienna",
        "slug": "vienna",
        "hasDescription": true
      }
    ],
    "slug": "austria"
  },
  {
    "name": "Czech Republic",
    "capitalCity": "Prague",
    "currencySymbol": "Kč",
    "currencyCode": "CZK",
    "callingCode": "+54",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Prague",
        "slug": "prague",
        "hasDescription": true
      }
    ],
    "slug": "czech-republic"
  },
  {
    "name": "Hungary",
    "capitalCity": "Budapest",
    "currencySymbol": "Ft",
    "currencyCode": "HUF",
    "callingCode": "+36",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Budapest",
        "slug": "budapest",
        "hasDescription": true
      }
    ],
    "slug": "hungary"
  },
  {
    "name": "Poland",
    "capitalCity": "Warsaw",
    "currencySymbol": "zł",
    "currencyCode": "PLN",
    "callingCode": "+48",
    "hasDescription": false,
    "hasFooter": false,
    "cities": [
      {
        "name": "Krakow",
        "slug": "krakow",
        "hasDescription": false
      },
      {
        "name": "Warsaw",
        "slug": "warsaw",
        "hasDescription": true
      }
    ],
    "slug": "poland"
  },
  {
    "name": "Belgium",
    "capitalCity": "Brussels",
    "currencySymbol": "€",
    "currencyCode": "EUR",
    "callingCode": "+32",
    "hasFooter": false,
    "cities": [
      {
        "name": "Brussels",
        "slug": "brussels",
        "hasDescription": false
      }
    ],
    "slug": "belgium"
  }
];
